import React from "react";
import PolicyLayout from "./PolicyLayout";
import "../css/policy.scss";

const sections = [
  {
    id: "overview",
    title: "About cookies and local storage",
    body: [
      "Cookies are small data files a website or service may store in a browser. Local storage is a related browser feature that can retain information on a device without sending it with every request.",
      "This policy describes the technologies intentionally used by the current nartvmora storefront and what may happen when a visitor follows a link to an independent payment or other service.",
    ],
  },
  {
    id: "current-use",
    title: "What this storefront stores",
    table: [
      ["nartvmora-cart", "Product identifier, selected size, colour and quantity. Used to keep the bag between pages and visits."],
      ["nartvmora-last-order", "Order reference, date, customer name, email, total and item count. Used to display the recent payment-result page."],
    ],
    body: [
      "These records use local storage and remain on the visitor's device until they are replaced, cleared through browser settings or removed by the browser. They are used for requested storefront functions, not behavioural advertising.",
    ],
  },
  {
    id: "server-technologies",
    title: "Server and essential technologies",
    body: [
      "Hosting, security and network providers may process request information or use essential technologies to deliver pages, balance traffic, prevent abuse and remember security state. Blocking essential storage can stop the bag, checkout or payment flow from working correctly.",
    ],
  },
  {
    id: "third-party",
    title: "Third-party payment and linked services",
    body: [
      "When checkout redirects to a hosted payment page, that provider may set its own cookies or similar technologies for authentication, fraud prevention, payment processing and preferences. Its policy and controls apply on its domain.",
      "A link to another website does not cause nartvmora to control that site's cookies. Review the destination's privacy information before providing data.",
    ],
    links: [{ to: "/payments", label: "Payments & billing" }],
  },
  {
    id: "analytics-advertising",
    title: "Analytics and advertising",
    body: [
      "The current storefront does not intentionally enable third-party behavioural advertising or non-essential analytics cookies. If those technologies are introduced, this policy and any consent or opt-out controls required by applicable law will be updated before they are activated for affected visitors.",
    ],
  },
  {
    id: "controls",
    title: "Browser controls",
    body: [
      "Most browsers allow a visitor to inspect, block or delete cookies and local storage for a site. Clearing nartvmora site data removes the saved bag and recent-order summary from that browser. Private browsing or device settings may also limit retention.",
      "Browser controls operate per browser and device. A payment provider's cookies must be managed on its service or through the browser's broader privacy settings.",
    ],
    links: [{ to: "/privacy-choices", label: "Your privacy choices" }],
  },
  {
    id: "updates-contact",
    title: "Updates and questions",
    body: [
      "This policy is reviewed when browser storage, analytics, advertising or service providers change. The effective date will be revised for published updates.",
      "Cookie and browser-storage questions can be sent to service@nartvmora.site.",
    ],
    links: [
      { to: "/privacy", label: "Privacy notice" },
      { to: "/contact", label: "Contact us" },
    ],
  },
];

function Cookies() {
  return (
    <PolicyLayout
      eyebrow="Legal"
      title="Cookie Policy"
      intro="How cookies and browser storage support this storefront and the controls available to visitors."
      updated="Effective 16 October 2026"
      sections={sections}
      action={{ to: "/contact", label: "Ask a cookie question" }}
    />
  );
}

export default Cookies;
